import React from "react";
import placeimg from "../../../images/placeholder.png";
import gymimage from "../../../images/gymgirl.jpg";
import { getImageUrl } from "../../helpers/Helpers";
import { BASE_URL_MEDIA } from "../../../api/Constants";

const UserManagementModal = ({
  isVisible,
  onClose,
  show,
  onToggleShow,
  assign,
  assigneDate,
  formattedDate,
  onAssignDateChange,
  onAssignChange,
  usersIds,
  groupId,
  onAssignNow,
  userinput,
  onUserInputChange,
  selectedusers,
  onRemoveUser,
  users,
  onToggleUser,
  onSetUsers,
  groupList,
  onGroupChange,
  detail,
  id,
  onDeleteGroupFromProg,
  onCompleteForGroup,
  onReOpenForGroup,
  onDeleteUserFromProg,
  onCompleteForUser,
  onReOpenForUser,
  onShowUserStats
}) => {
  if (!isVisible) return null;

  return (
    <div className="excercise-modal">
      <div className="child-modal">
        <div className="add-excersie">
          <button
            className="button"
            onClick={onToggleShow}
          >
            Assign program to users
          </button>
          <i
            className="fa fa-times pointer"
            onClick={onClose}
          ></i>
        </div>

        {show && (
          <>
            <div className="form-group">
              <label htmlFor="">Assign date</label>
              <input
                type="date"
                className="form-control mb-1"
                min={formattedDate}
                value={assigneDate}
                onChange={onAssignDateChange}
              />
            </div>
            
            <div className="radios radioss my-2">
              <label>
                <input
                  type="radio"
                  value="users"
                  checked={assign === "users"}
                  onChange={onAssignChange}
                />
                Assign to others
              </label>
              <label>
                <input
                  type="radio"
                  value="groups"
                  checked={assign === "groups"}
                  onChange={onAssignChange}
                />
                For groups
              </label>

              {(usersIds.length > 0 || groupId) && (
                <button className="button mt-2" onClick={onAssignNow}>
                  Assign now
                </button>
              )}
            </div>

            <div className="col-12">
              {assign === "users" && (
                <div className="search-filter">
                  <div className="form-group">
                    <label htmlFor="">Search users</label>
                    <input
                      type="text"
                      value={userinput}
                      onChange={onUserInputChange}
                      placeholder="Search users"
                      className="form-control input"
                    />
                  </div>
                  
                  <div className="selected-users">
                    {selectedusers?.length > 0 && (
                      <ul>
                        {selectedusers?.map((suser) => (
                          <li key={suser?.id}>
                            <div className="img">
                              <i
                                className="fa fa-times"
                                onClick={() => onRemoveUser(suser)}
                              ></i>
                              {suser?.image ? (
                                <img src={getImageUrl(suser?.image, BASE_URL_MEDIA)} alt={suser?.name} />
                              ) : (
                                <img src={gymimage} alt="Default" />
                              )}
                            </div>
                            <span className="name">{suser?.name}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  
                  <div className="user-list">
                    {users?.length > 0 && (
                      <i
                        className="fa fa-times"
                        onClick={() => onSetUsers([])}
                      ></i>
                    )}
                    {users?.length > 0 && (
                      <ul>
                        {users?.map((user) => (
                          <li
                            key={user?.id}
                            className={selectedusers.includes(user) ? "selected" : ""}
                            onClick={() => onToggleUser(user)}
                          >
                            <div className="img">
                              {user?.image ? (
                                <img src={getImageUrl(user?.image, BASE_URL_MEDIA)} alt={user?.name} />
                              ) : (
                                <img src={gymimage} alt="Default" />
                              )}
                            </div>
                            <span className="name">{user?.name}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              )}
              
              {assign === "groups" && (
                <div className="search-filter mb-3">
                  <div className="form-group">
                    <label htmlFor="single-select">Select a group</label>
                    <select
                      id="single-select"
                      onChange={onGroupChange}
                      className="form-control input"
                      value={groupId || ""}
                    >
                      <option value="">Select a group</option>
                      {groupList?.map((option) => (
                        <option key={option?.id} value={option?.id}>
                          {option?.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        <div className="users-filter">
          {detail?.groups?.length > 0 && (
            <>
              <h3 className="title">Groups</h3>
              <ul className="mb-3">
                {detail?.groups?.map((group) => (
                  <li key={group?.id}>
                    <div className="icons">
                      <i
                        className="fa fa-trash"
                        onClick={() => onDeleteGroupFromProg(id, group?.id)}
                      ></i>
                      {(group.status === 1 || group.status === 2) &&
                        group.is_program_complete === 0 && (
                          <i
                            className="fa-solid fa-circle-check"
                            onClick={() => onCompleteForGroup(id, group?.id)}
                          ></i>
                        )}
                      {group.is_program_complete === 1 && (
                        <i
                          className="fa-solid fa-lock-open"
                          onClick={() => onReOpenForGroup(id, group?.id)}
                        ></i>
                      )}
                    </div>
                    <div className="img">
                      {group?.image ? (
                        <img src={getImageUrl(group.image, BASE_URL_MEDIA)} alt={group.title} />
                      ) : (
                        <img src={placeimg} alt="Default" />
                      )}
                    </div>
                    <div className="data">
                      <span className="titlee">{group.title}</span>
                      {group.program_start_date !== null && (
                        <span className="date">{group.program_start_date}</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
          
          {detail?.users?.length > 0 && (
            <>
              <h3 className="title">Users</h3>
              <ul>
                {detail?.users?.map((user) => (
                  <li key={user?.id}>
                    <div className="icons">
                      <i
                        className="fa fa-trash"
                        onClick={() => onDeleteUserFromProg(id, user?.id)}
                      ></i>
                      {(user.status === 1 || user.status === 2) &&
                        user.is_program_complete === 0 && (
                          <i
                            className="fa-solid fa-circle-check"
                            onClick={() => onCompleteForUser(id, user?.id)}
                          ></i>
                        )}
                      {user.is_program_complete === 1 && (
                        <i
                          className="fa-solid fa-circle-check"
                          style={{ color: "#ccc" }}
                          onClick={() => onReOpenForUser(id, user?.id)}
                        ></i>
                      )}
                    </div>
                    <div className="img clickable" onClick={() => onShowUserStats(user?.id ?? 0)}>
                      {user?.image ? (
                        <img src={getImageUrl(user.image, BASE_URL_MEDIA)} alt={user.name} />
                      ) : (
                        <img src={placeimg} alt="Default" />
                      )}
                    </div>
                    <div className="data">
                      <span className="titlee clickable" onClick={() => onShowUserStats(user?.id ?? 0)}>
                        {user.name}
                      </span>
                      {getUserStatusBadge(user.status)}
                      {user.is_program_complete === 1 && (
                        <p className="date">Completed</p>
                      )}
                      {user?.program_start_date !== null &&
                        user.is_program_complete === 0 && (
                          <p className="date">{user?.program_start_date}</p>
                        )}
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const getUserStatusBadge = (status) => {
  const statusConfig = {
    0: { text: "Pending", style: { backgroundColor: "#ccc", color: "#333" } },
    1: { text: "Report Access Not Granted", style: { backgroundColor: "orange", color: "#333" } },
    2: { text: "Report Access Granted", style: { backgroundColor: "green", color: "#fff" } },
    3: { text: "Declined", style: { backgroundColor: "red", color: "#fff" } }
  };

  const config = statusConfig[status];
  if (!config) return null;

  return (
    <span className="status" style={config.style}>
      {config.text}
    </span>
  );
};

export default UserManagementModal;
